import { render, staticRenderFns } from "./ClaimsCalculatorRow.vue?vue&type=template&id=36716b38&"
import script from "./ClaimsCalculatorRow.vue?vue&type=script&lang=js&"
export * from "./ClaimsCalculatorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports